const MOBILE_MQ = '(max-width: 767px)';

let instances = [];

export default class Accordion {
  constructor(el) {
    this.el = el;
    this.mq = window.matchMedia(MOBILE_MQ);
    this.rows = Array.from(this.el.querySelectorAll('.accordion-row'));
    this.buttons = Array.from(this.el.querySelectorAll('.accordion-button'));
    this.onClick = this.handleClick.bind(this);
    this.onMediaChange = this.handleMediaChange.bind(this);

    this.mq.addEventListener('change', this.onMediaChange);
    this.bindEvents();
    this.handleMediaChange();
  }

  bindEvents() {
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', this.onClick);
      button.dataset.accordionIndex = String(index);
    });
  }

  handleClick(event) {
    if (!this.mq.matches) return;

    const button = event.currentTarget;
    const index = Number(button.dataset.accordionIndex);

    if (Number.isNaN(index)) return;

    this.toggleRow(index);
  }

  toggleRow(index) {
    this.rows.forEach((row, i) => {
      const isExpanded = row.getAttribute('aria-expanded') === 'true';
      const button = this.buttons[i];
      const nextExpanded = i === index ? !isExpanded : false;

      row.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      button?.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
    });
  }

  handleMediaChange() {
    if (this.mq.matches) return;

    this.rows.forEach((row, i) => {
      row.setAttribute('aria-expanded', 'true');
      this.buttons[i]?.setAttribute('aria-expanded', 'true');
    });
  }

  destroy() {
    this.mq.removeEventListener('change', this.onMediaChange);

    this.buttons.forEach((button) => {
      button.removeEventListener('click', this.onClick);
    });
  }
}

export function initAccordion() {
  destroyAccordion();

  $('.js-accordion').each((_, el) => {
    instances.push(new Accordion(el));
  });
}

export function destroyAccordion() {
  instances.forEach((instance) => instance.destroy());
  instances = [];
}
